<template>
<!-- eslint-disable max-len -->
<div>
  <my-groups/>
</div>
</template>

<script>
import MyGroups from './MyGroups';

export default {
  components: {
    MyGroups
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue